module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showFooter) ? _c('div', {
    attrs: {
      "id": "plex-footer"
    }
  }, [_c('div', {
    class: ['footer-content', {
      'activity-padding': ['/', '/download'].includes(_vm.$route.path)
    }]
  }, [_c('div', {
    staticClass: "link-content"
  }, [_c('ul', [_c('li', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("aboutUs")))]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/user-agreement"
    }
  }, [_vm._v(_vm._s(_vm.$t("userAgreement")))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/affiliate-program"
    }
  }, [_vm._v(_vm._s(_vm.$t("affiliate")))])], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "download"
  }, [_c('li', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("download")))]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/download?platform=windows"
    }
  }, [_vm._v("Windows")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/download?platform=mac"
    }
  }, [_vm._v("macOS")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/download?platform=ios"
    }
  }, [_vm._v("iOS")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/download?platform=android"
    }
  }, [_vm._v("Android")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/download?platform=ubuntu"
    }
  }, [_vm._v("Linux")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/download?platform=androidTV"
    }
  }, [_vm._v("Android TV")])], 1)]), _vm._v(" "), _c('choose-lang-in-footer'), _vm._v(" "), _c('ul', {
    staticClass: "help",
    style: ({
      '--positionTop': _vm.height
    })
  }, [_c('li', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("help")))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/faq"
    }
  }, [_vm._v(_vm._s(_vm.$t("faq")))])], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "join-us"
  }, [_c('li', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("joinUs")))]), _vm._v(" "), _vm._m(1)])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "warning"
  }, [_vm._v(_vm._s(_vm.$t("warning")))])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', [_vm._v("iplexservice@gmail.com")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "facebook-link",
    attrs: {
      "rel": "noopener noreferrer",
      "href": "https://www.facebook.com/groups/plexvpn/",
      "target": "_blank"
    }
  }, [_vm._v("Facebook")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-974163aa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/Footer.vue
// module id = 1370
// module chunks = 1